/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useState, useContext, useEffect } from 'react';
import { Badge, Collapse } from 'reactstrap';
import Alert from 'react-s-alert';

// context imports
import { ThemeContext } from '../../contexts/ThemeContext';

// service imports
import GeneralService from '../../services/GeneralService';

// local imports
import Session from './Session';

const UpcomingSession = props => {

    // context
    const { theme, colors } = useContext(ThemeContext);

    // states
    const [isUpcomingSessionOpen, setIsUpcomingSessionOpen] = useState(true);
    const [sessionList, setSessionList] = useState([]);
    const [newUpcomingSession, setNewUpcomingSession] = useState([]);
    const [newRescheduledSession, setNewRescheduledSession] = useState([]);

    // utility functions
    const toggleUpcomingSession = () => setIsUpcomingSessionOpen(!isUpcomingSessionOpen);

    // useEffect
    useEffect(() => {
        try {
            if (props.sessions) {
                setSessionList(props.sessions);
            }
            if (props.newUpcomingSession) {
                setNewUpcomingSession(props.newUpcomingSession);
            }
            if (props.newRescheduledSession) {
                setNewRescheduledSession(props.newRescheduledSession);
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at User UpcomingSession useEffect', 'Error in try catch block', err.stack);
        }
    }, [props.sessions])

    // function's return
    return (
        <div className="p-3 mt-3" style={theme.card} id="upcomingSessions">
            <div className="row px-3" onClick={toggleUpcomingSession} style={{ cursor: "pointer" }}>
                <span id="upComingSessions" style={theme.headingBold}>Upcoming Sessions <Badge style={{ backgroundColor: colors.primary }}>{sessionList.length}</Badge> </span>
                {
                    sessionList.length ?
                        isUpcomingSessionOpen
                            ? <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-up"></i>{newUpcomingSession.length + newRescheduledSession.length > 0 ? <Badge className="ml-1" style={{ backgroundColor: colors.warning }}>{newUpcomingSession.length + newRescheduledSession.length}</Badge> : null}</span>
                            : <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-down"></i>{newUpcomingSession.length + newRescheduledSession.length > 0 ? <Badge className="ml-1" style={{ backgroundColor: colors.warning }}>{newUpcomingSession.length + newRescheduledSession.length}</Badge> : null}</span>
                        : null
                }

            </div>

            <Collapse isOpen={sessionList.length ? isUpcomingSessionOpen : false}>
                <hr />
                {
                    sessionList.map((item, index) => (
                        <Session key={index} selectedTimeZone={props.selectedTimeZone} handleModal={props.handleModal} detail={item} type="Upcoming" index={index} history={props.history} newUpcomingSession={newUpcomingSession} newRescheduledSession={newRescheduledSession} />
                    ))
                }
            </Collapse>


        </div>
    )
}

export default UpcomingSession;